import { render, staticRenderFns } from "./ViewContainer.vue?vue&type=template&id=1a64bca6&scoped=true&"
var script = {}
import style0 from "./ViewContainer.vue?vue&type=style&index=0&id=1a64bca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64bca6",
  null
  
)

export default component.exports